/* eslint-disable no-useless-escape */
export const normalizeName = (name: string): string => {
    return name
        .normalize('NFD') // Normalize the string to decompose accents
        .replace(/[\u0300-\u036f]/g, '') // Remove the diacritical marks (accents)
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, '_') // Replace spaces with underscores
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters (except underscore and dash)
}
